var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589417,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F1ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_6577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 21.2561C22.4066 21.2561 24.3637 19.4621 24.3637 17.2561V16.5894C24.3637 14.3834 22.4066 12.5894 20.0001 12.5894C17.5935 12.5894 15.6364 14.3834 15.6364 16.5894V17.2561C15.6364 19.4621 17.5935 21.2561 20.0001 21.2561Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3251 23.2434C21.904 22.3748 18.0967 22.3748 14.6749 23.2434C13.1004 23.6434 12 24.9654 12 26.4594V28.5894H28V26.4594C28 24.9654 26.8996 23.6434 25.3251 23.2434Z",
    fill: "#9C82FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_6577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5894)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsProfile);
export default __webpack_public_path__ + "static/media/ps-profile.ad33cb1a56e89c944ff9e65674987ea8.svg";
export { ForwardRef as ReactComponent };